<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-input size="mini" style="width: 200px;" placeholder="关键字" clearable @clear="refetchData"
                prefix-icon="el-icon-search" v-model="keyword" @keyup.native.enter="refetchData"></el-input>
            <el-button size="mini" class="margin-l" type="primary" @click.stop="refetchData">搜索</el-button>
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top" :page-size="pageSize">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="50"></el-table-column>
                <el-table-column label="姓名" align="center" prop="name" width="200"></el-table-column>
                <el-table-column label="年龄" align="center" prop="age" width="80"></el-table-column>
                <el-table-column label="电话" align="center" prop="phone" width="140"></el-table-column>
                <el-table-column label="余额" align="center" prop="surplus" width="100" sortable>
                    <template slot-scope="scope">
                        {{scope.row.surplus ? scope.row.surplus : 0}}
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remarks" width="200"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-user ref="edit" @fetch-data="fetchData"></dialog-edit-user>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditUser from "../components/dialog/dialogEditUser";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";

export default {
    components: {
        DialogEditUser,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            pageSize: 100 * 10000,
        };
    },
    created() { },
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() { },
    methods: {
        async fetchSurplus() {
            if (!this.data.length) return;
            let res = await HttpClient.post("/value/getSurplus", {
                ids: this.data.map((it) => it._id).join("|"),
            });
            this.data.forEach((user) => {
                user.surplus = res[user._id] || 0;
            });
            this.data = JSON.parse(JSON.stringify(this.data)); // 深拷贝，避免 Vue 的响应式问题
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "i",
                };
                cond["$or"] = [
                    {
                        name: regex,
                    },
                    {
                        phone: regex,
                    },
                    {
                        remarks: regex,
                    },
                ];
            }
            let res = await HttpClient.post("/restful", {
                model: "User",
                cond,
                sort: {
                    _id: -1,
                },
                pageSize: this.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);

            await this.fetchSurplus();
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("User", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
